import { WidgetState } from '../ducks/type';
import { getEffectiveWidgetType } from './getEffectiveWidgetType';

/**
 *  Check if a widget has a valid effective type.
 *
 *  <i>Effective type => Legacy widget type OR Widget v2 type {@see getEffectiveWidgetType}.</i>
 *
 *  @param validWidgetTypes  if undefined, no check is applied; otherwise, the widget effective type should be in the array
 *  @param widget            widget to check.
 */
export const isWidgetOfValidType =
    (validWidgetTypes?: string[]) =>
    (widget: Partial<WidgetState>): boolean =>
        !validWidgetTypes || validWidgetTypes.includes(getEffectiveWidgetType(widget));
